import * as Yup from "yup";

export const initialValuesUsers = {
    "role": ["Usuario"]
}

export const validationSchemaUsers = Yup.object().shape({
    "role": Yup.array().required('El rol del usuario es requerido.')
})